import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function Footer() {
  const { t } = useTranslation();
  return (
    <footer className="relative mt-24 bg-slate-950 text-slate-300 overflow-hidden">
      <div className="h-1 w-full" style={{ background: "linear-gradient(90deg,#DE0F72,#FF9900)" }} />
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-12 grid md:grid-cols-2 gap-8">
        <div>
          <img src={`${process.env.PUBLIC_URL}/logos/Logotype_WHITE.svg`} alt="Ariovis" className="h-7 w-auto mb-4" />
          <p className="text-sm text-slate-400 leading-relaxed max-w-sm">
            {t("footer.tagline")}
          </p>
          <div className="mt-5 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs">
            <a
              href="https://ariovis.fr"
              target="_blank"
              rel="noopener noreferrer"
              className="text-slate-400 hover:text-white transition inline-flex items-center gap-1"
              data-testid="footer-link-home"
            >
              ariovis.fr <ArrowUpRight className="w-3 h-3" />
            </a>
            <a
              href="https://ariovis.fr/produits"
              target="_blank"
              rel="noopener noreferrer"
              className="text-slate-400 hover:text-white transition inline-flex items-center gap-1"
              data-testid="footer-link-products"
            >
              {t("header.nav_products")} <ArrowUpRight className="w-3 h-3" />
            </a>
            <Link
              to="/mentions-legales"
              className="text-slate-400 hover:text-white transition"
              data-testid="footer-legal"
            >
              {t("footer.legal_link")}
            </Link>
          </div>
        </div>
        <div className="md:text-right flex flex-col md:items-end justify-between gap-4">
          <div>
            <div className="text-[11px] tracking-[0.18em] uppercase text-slate-500 mb-3">
              {t("footer.contact_title")}
            </div>
            <a
              href="https://ariovis.fr/contact"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-contact-link"
              className="group inline-flex items-center gap-2 text-base font-semibold text-white hover:text-fuchsia-400 transition"
            >
              {t("footer.contact_link_label")}
              <ArrowUpRight className="w-4 h-4 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
            </a>
          </div>
          <div className="text-xs text-slate-500">
            © {new Date().getFullYear()} {t("footer.copyright")}
          </div>
        </div>
      </div>
    </footer>
  );
}
